/**
 * @generated SignedSource<<6e868f4955c0648fe86a9af5aea43cac>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type PrefillIdentityDetailsResponseError = 'INVALID_AUTH' | 'UNEXPECTED_ERROR' | '%future added value';
export type ResidentialAddressPagePrefillQuery$variables = Record<PropertyKey, never>;
export type ResidentialAddressPagePrefillQuery$data = {
  readonly prefillIdentityDetails: {
    readonly data: {
      readonly residentialAddress: {
        readonly id: string;
        readonly locality: string;
        readonly primaryAddressLine: string;
        readonly secondaryAddressLine: string | null;
        readonly streetAddress: string;
        readonly subdivision: string;
        readonly zip: string;
      };
    } | null;
    readonly errors: ReadonlyArray<PrefillIdentityDetailsResponseError>;
  };
};
export type ResidentialAddressPagePrefillQuery = {
  response: ResidentialAddressPagePrefillQuery$data;
  variables: ResidentialAddressPagePrefillQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
    {
      alias: null,
      args: [
        {
          kind: 'Literal',
          name: 'q',
          value: {},
        },
      ],
      concreteType: 'PrefillIdentityDetailsResponseValidation',
      kind: 'LinkedField',
      name: 'prefillIdentityDetails',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'PrefillIdentityDetailsResponse',
          kind: 'LinkedField',
          name: 'data',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Address',
              kind: 'LinkedField',
              name: 'residentialAddress',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'id',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'streetAddress',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'primaryAddressLine',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'secondaryAddressLine',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'locality',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'subdivision',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'zip',
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'errors',
          storageKey: null,
        },
      ],
      storageKey: 'prefillIdentityDetails(q:{})',
    },
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'ResidentialAddressPagePrefillQuery',
      selections: v0 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'ResidentialAddressPagePrefillQuery',
      selections: v0 /*: any*/,
    },
    params: {
      cacheID: '0cb58fe5fb03115ce7be6c20dfe210ad',
      id: null,
      metadata: {},
      name: 'ResidentialAddressPagePrefillQuery',
      operationKind: 'query',
      text: 'query ResidentialAddressPagePrefillQuery {\n  prefillIdentityDetails(q: {}) {\n    data {\n      residentialAddress {\n        id\n        streetAddress\n        primaryAddressLine\n        secondaryAddressLine\n        locality\n        subdivision\n        zip\n      }\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = '9a4ad3eb29eb801aec5b23d7775ec2a6';

export default node;
